export class StacyMessagesModel {
  constructor(public instantMessage: string, public additionalMessage: string, public additionalMessageTimeout: number, public document?: { docType: string, field: string}) { }
}
